module.exports = __webpack_public_path__ + "static/media/34DSS12.3513af52.jpg";